/**
 * El «ahora» de quien necesita saber el mes en curso. Un solo sitio para que
 * las pruebas lo fijen sin tocar los temporizadores.
 */
export const now = (): Date => new Date();
